import React from 'react';
import { MyShiftContainer } from './container/MyShiftContainer';

/**
 * MyShiftページコンポーネント
 * @description マイシフト画面のエントリーポイント
 *              React Routerから直接呼び出される
 * @route /my-shift
 */
export const MyShiftPage: React.FC = () => {
  return <MyShiftContainer />;
};

export default MyShiftPage;
